import { RowProjectDto } from "@/dtos";
import { Project } from "@/entities";

export const formatRowProjectDto = (projects: Project[]): RowProjectDto[] => {
    return projects.map(x => {
        const row: RowProjectDto = {
            ...x,
            active: x.is_active ? 'Activo' : 'Inactivo'
        }

        return row;
    });
}